export default __webpack_public_path__ + "static/media/logo.4020d427.svg";